export const URL_PATHS = {
  PROJECTS: "/progetti/",
  PROJECT: "/progetto/",
  BIO: "/bio/",
  HOME: "/",
};
